(()=>{
  const template=document.getElementById('sp-campaign-template');
  if(!template)return;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  function mount(){
    const widget=document.querySelector('.gta-widget.gta-bar');
    if(!widget||widget.classList.contains('sp-campaign-ready'))return !!widget;
    const content=widget.querySelector('.gta-content');
    const container=widget.querySelector('.gta-content__container');
    if(!content||!container)return false;
    const fragment=template.content.cloneNode(true);
    const copy=fragment.querySelector('.sp-campaign-copy');
    const motion=fragment.querySelector('.sp-campaign-motion');
    const track=document.createElement('span');
    track.className='sp-campaign-track';
    track.setAttribute('aria-hidden','true');
    for(let n=0;n<3;n++){
      const tile=document.createElement('span');
      tile.className='sp-campaign-tile';
      for(let i=0;i<4;i++)tile.append(document.createElement('i'));
      track.append(tile);
    }
    content.append(copy);
    container.append(track,motion);
    let paused=reduced.matches;
    function update(){
      widget.classList.toggle('sp-campaign-paused',paused);
      motion.textContent=paused?motion.dataset.play:motion.dataset.pause;
      motion.setAttribute('aria-pressed',String(paused));
      container.style.setProperty('--sp-motion-state',paused?'paused':'running');
    }
    motion.addEventListener('click',()=>{paused=!paused;update();});
    reduced.addEventListener('change',e=>{paused=e.matches;update();});
    widget.classList.add('sp-campaign-ready');
    update();
    return true;
  }
  if(mount())return;
  const observer=new MutationObserver(()=>{if(mount())observer.disconnect();});
  observer.observe(document.documentElement,{childList:true,subtree:true});
  setTimeout(()=>observer.disconnect(),30000);
})();
